var _path, _rect, _text, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L12 5L16 2",
    stroke: "#008662",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2,
    stroke: "#008662",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 14.5,
    fill: "#008662",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 5,
    textAnchor: "middle",
    letterSpacing: 0.5
  }, "LIVE")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19L6 22M17 19L18 22",
    stroke: "#008662",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/live-icon.2760155bc123b40b4ca85d5406f4db5e.svg";
export { ForwardRef as ReactComponent };